<div class="modal-body bg-gris-1 p-0 pb-6 f-poppins">
    <i type="button" (click)="closebuttonsuc()" class="color-4 fs-2 far fa-times-circle position-absolute end-0 top-0 m-3 close-button-succes team"></i>
    <div class="text-center">
        <h2 class="text-1 fs-4 mt-5">{{"SIGNUP.success" | translate}}</h2>
        <img class=" mb-4" src="assets/img/home/success 1.png">
        <p class="text-muted font-large mt-3 h3">{{successmessage}}</p>
    </div>
</div>